import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import { PageHeader } from "procurement/design"
import "procurement/design/tokens.css"
import "./tokens.css"
import "./pageRefined.css"
import { RefinedContext } from "./refined"

// Every procurement list/detail screen renders inside <Page>. It owns the
// design-system root (`.pc-root`), page padding, and a consistent header.
// `className` lets a screen opt into its own scoped redesign rules (see
// orderRedesign.css) without touching the other procurement pages.
export const Page = ({ breadcrumb = [], title, subtitle, actions, className = "", children }) => (
  <DashboardLayout>
    <div className="pc-root">
      <div className={`pc-page${className ? ` ${className}` : ""}`}>
        <PageHeader breadcrumb={breadcrumb} title={title} subtitle={subtitle} actions={actions} />
        <RefinedContext.Provider value={className.includes("pc-page--refined")}>
          {children}
        </RefinedContext.Provider>
      </div>
    </div>
  </DashboardLayout>
)

// Surface card with an optional icon + title + subtitle header and a right-side
// action slot. `flush` drops body padding (used to let a table sit edge-to-edge).
// `tone` (blue|yellow|pink|purple) tints the icon chip + adds a hairline top
// accent — a very subtle way to tell functional sections apart on a page with
// several cards (e.g. Create Order) without turning any of them into a fully
// coloured block. Omit it for the plain/default look every other page uses.
export const Card = ({ icon, title, subtitle, action, flush, tone, className = "", children, style }) => (
  <section
    className={`pc-card${tone ? ` pc-card--${tone}` : ""}${className ? ` ${className}` : ""}`}
    style={style}
  >
    {(title || action) && (
      <div className="pc-card-head">
        <div className="pc-card-head-l">
          {icon && <span className={`pc-card-ico${tone ? ` pc-card-ico--${tone}` : ""}`}>{icon}</span>}
          <div style={{ minWidth: 0 }}>
            {title && <div className="pc-card-title">{title}</div>}
            {subtitle && <div className="pc-card-subtitle">{subtitle}</div>}
          </div>
        </div>
        {action && <div>{action}</div>}
      </div>
    )}
    <div className={`pc-card-body${flush ? " pc-flush" : ""}`}>{children}</div>
  </section>
)

export default Page
